import {useQueryClient} from '@tanstack/react-query';
import {GetWellBornEligibilityResponse} from 'domain/usecases/private/well-born/get-well-born-eligibility';

import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';

export function useWellBornEligibility() {
	const queryClient = useQueryClient();

	const setEligibilityData = (data: GetWellBornEligibilityResponse) => {
		queryClient.setQueryData([QUERY_KEYS.WELL_BORN_ELIGIBILITY], data);
	};

	const eligibilityData = queryClient.getQueryData<GetWellBornEligibilityResponse>([
		QUERY_KEYS.WELL_BORN_ELIGIBILITY,
	]);

	const clearEligibilityData = () => {
		queryClient.removeQueries({queryKey: [QUERY_KEYS.WELL_BORN_ELIGIBILITY]});
	};

	return {
		eligibilityData,
		setEligibilityData,
		clearEligibilityData,
	};
}
